/**
 * UI strings. Hebrew is the only locale today; every user-facing string lives
 * here so an English dictionary with the same shape can be added later
 * (switch `active` and `locale`, and set <html dir>).
 */
import { he } from './he';

export type Dictionary = typeof he;
const active: Dictionary = he;

export const t = active;
export const locale = { code: 'he', intl: 'he-IL', dir: 'rtl' as const, justNow: active.common.justNow };
